export default __webpack_public_path__ + "static/car11-29fc2c0fb6919e2e8ae50012456f3772.glb";